import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Label, Input, FormFeedback } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';

const Edit_organization = (props) => {
	document.title = "Edit Organization";
	const history = useHistory();
	const { postRequest } = useRequests();

	const [AlertData, setAlertData] = useState({ variant: '', message: '' });
	const [orgData, setOrgData] = useState({
		orgName: "",
		userid: "",
		location: "",
		supervisor: "",
		email: "",
		mobile: ""
	});

	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData({ variant: '', message: '' });
		}, 5000);
	};

	const validationSchema = Yup.object({
		orgName: Yup.string().required("Organization Name is required"),
		userid: Yup.string().required("UserID is required"),
		location: Yup.string().required("Location is required"),
		supervisor: Yup.string().required("Supervisor Name is required"),
		email: Yup.string().email("Invalid email").required("Email is required"),
		mobile: Yup.string()
			.required("Mobile Number is required")
			.matches(/^[0-9]+$/, "Mobile number must be digits only!")
			.test(
				"len",
				"Mobile number should be 9 digits for Spain/France/Belgium, 10 digits for other countries!",
				function (value) {
					if (!value) return false;
					return value.length === 9 || value.length === 10;
				}
			),
	});

	const formik = useFormik({
		enableReinitialize: false,
		initialValues: orgData,
		validationSchema,
		onSubmit: async () => {
			try {
				const payload = {
					organization_name: formik.values.orgName,
					userid: formik.values.userid,
					location: formik.values.location,
					supervisor: formik.values.supervisor,
					email: formik.values.email,
					mobile: formik.values.mobile,
				};

				let submit1 = document.getElementById('submit1');
				submit1.disabled = true;
				submit1.textContent = 'Processing...';

				const jsonpar = JSON.stringify({
					a_id: atob(props.match.params.id),
					data: payload
				});

				const res = await postRequest('update-organization', jsonpar);
				if (res && res.code === 200) {
					history.push({
						pathname: '/organization_management',
						state: { code: 200, status: 'success', message: res.message }
					});
				} else {
					setAlertData({ variant: 'error', message: res.message });
				}
				resetAlertData();
				submit1.disabled = false;
				submit1.textContent = 'Update';
			} catch (error) {
				console.error("Error : ", error);
			}
		}
	});

	const handleFieldChange = (e) => {
		const { name, value } = e.target;
		setOrgData((prev) => ({ ...prev, [name]: value }));
		formik.setFieldValue(name, value);
	};

	const handleLoadGetOrganizationInfo = async () => {
		const jsonpar = JSON.stringify({
			a_id: atob(props.match.params.id)
		});
		const res = await postRequest('get-organization-info', jsonpar);

		if (res && res.code === 200 && res.data) {
			const newData = {
				orgName: res.data.organization_name || "",
				userid: res.data.userid || "",
				location: res.data.location || "",
				supervisor: res.data.supervisor || "",
				email: res.data.email || "",
				mobile: res.data.mobile || ""
			};
			setOrgData(newData);
			formik.setValues(newData);
		} else {
			setAlertData({ variant: 'error', message: res.message });
			resetAlertData();
		}
	};

	useEffect(() => {
		if (!props.match.params.id) {
			history.push({
				pathname: '/organization_management',
				state: { code: 401, status: 'error', message: 'ID not found! Please provide a valid ID.' }
			});
		} else {
			handleLoadGetOrganizationInfo();
		}
		// eslint-disable-next-line
	}, []);

	return (
		<React.Fragment>
			{AlertData.message && <Snackbars variant={AlertData.variant} message={AlertData.message} />}
			<div className="page-content">
				<Container fluid>
					<Breadcrumbs title={props.t("Utilize Safety")} breadcrumbItem={props.t("Edit Organization")} />
					<Card>
						<CardBody>
							<Row className="mt-3">
								<Col md={4}>
									<div className="mb-3">
										<Label className="form-label">Organization Name :</Label>
										<Input
											name="orgName"
											type="text"
											placeholder="Enter Organization Name"
											value={formik.values.orgName}
											onChange={handleFieldChange}
											onBlur={formik.handleBlur}
											invalid={formik.touched.orgName && !!formik.errors.orgName}
										/>
										{formik.touched.orgName && formik.errors.orgName && (
											<FormFeedback type="invalid">{formik.errors.orgName}</FormFeedback>
										)}
									</div>
								</Col>
								<Col md={4}>
									<div className="mb-3">
										<Label className="form-label">UserID :</Label>
										<Input
											name="userid"
											type="text"
											placeholder="Enter UserID"
											value={formik.values.userid}
											onChange={handleFieldChange}
											onBlur={formik.handleBlur}
											invalid={formik.touched.userid && !!formik.errors.userid}
											disabled
										/>
										{formik.touched.userid && formik.errors.userid && (
											<FormFeedback type="invalid">{formik.errors.userid}</FormFeedback>
										)}
									</div>
								</Col>
								<Col md={4}>
									<div className="mb-3">
										<Label className="form-label">Location :</Label>
										<Input
											name="location"
											type="text"
											placeholder="Enter Location"
											value={formik.values.location}
											onChange={handleFieldChange}
											onBlur={formik.handleBlur}
											invalid={formik.touched.location && !!formik.errors.location}
										/>
										{formik.touched.location && formik.errors.location && (
											<FormFeedback type="invalid">{formik.errors.location}</FormFeedback>
										)}
									</div>
								</Col>
							</Row>
							<Row>
								<Col md={4}>
									<div className="mb-3">
										<Label className="form-label">Supervisor Name :</Label>
										<Input
											name="supervisor"
											type="text"
											placeholder="Enter Supervisor Name"
											value={formik.values.supervisor}
											onChange={handleFieldChange}
											onBlur={formik.handleBlur}
											invalid={formik.touched.supervisor && !!formik.errors.supervisor}
										/>
										{formik.touched.supervisor && formik.errors.supervisor && (
											<FormFeedback type="invalid">{formik.errors.supervisor}</FormFeedback>
										)}
									</div>
								</Col>
								<Col md={4}>
									<div className="mb-3">
										<Label className="form-label">Email :</Label>
										<Input
											name="email"
											type="email"
											placeholder="Enter Email"
											value={formik.values.email}
											onChange={handleFieldChange}
											onBlur={formik.handleBlur}
											invalid={formik.touched.email && !!formik.errors.email}
											disabled
										/>
										{formik.touched.email && formik.errors.email && (
											<FormFeedback type="invalid">{formik.errors.email}</FormFeedback>
										)}
									</div>
								</Col>
								<Col md={4}>
									<div className="mb-3">
										<Label className="form-label">Mobile Number :</Label>
										<Input
											name="mobile"
											type="text"
											placeholder="Enter Mobile Number"
											value={formik.values.mobile}
											onChange={handleFieldChange}
											onBlur={formik.handleBlur}
											invalid={formik.touched.mobile && !!formik.errors.mobile}
											disabled
										/>
										{formik.touched.mobile && formik.errors.mobile && (
											<FormFeedback type="invalid">{formik.errors.mobile}</FormFeedback>
										)}
									</div>
								</Col>
							</Row>
							<div className="text-left mt-2">
								<button
									type="button"
									id="submit1"
									onClick={(e) => {
										e.preventDefault();
										formik.handleSubmit();
									}}
									className="btn btn-primary me-2"
								>
									Update
								</button>
								<Link to="/organization_management" className="btn btn-light me-2">Cancel</Link>
							</div>
						</CardBody>
					</Card>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default withTranslation()(Edit_organization);
